import { CancelTokenSource } from 'axios';
import axios from 'services/http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/treatment-prescriptions`;

export const addTreatmentPrescription = (treatmentId: number,
                                         file: File,
                                         onUploadProgress: (progressEvent: ProgressEvent) => void,
                                         source: CancelTokenSource) => {
  let bodyFormData = new FormData();
  bodyFormData.append('file', file);

  const config = {
    cancelToken: source.token,
    onUploadProgress: onUploadProgress
  };

  return axios
      .post(`${apiUri}/${treatmentId}`, bodyFormData, config)
      .then(response => response.data);
};

export const addTempTreatmentPrescription = (tempTreatmentId: number | undefined,
                                             file: File,
                                             onUploadProgress: (progressEvent: ProgressEvent) => void,
                                             source: CancelTokenSource): Promise<number> => {
  let bodyFormData = new FormData();
  bodyFormData.append('file', file);

  const config = {
    cancelToken: source.token,
    onUploadProgress: onUploadProgress
  };

  const uriSuffix = tempTreatmentId ? `/${tempTreatmentId}` : '';

  return axios
      .post(`${apiUri}/temp${uriSuffix}`, bodyFormData, config)
      .then(response => response.data);
};

export const deleteTreatmentPrescription = (treatmentId: number, source: CancelTokenSource) => {
  return axios.delete(`${apiUri}/${treatmentId}`, {cancelToken: source.token})
      .then();
};

export const deleteTempTreatmentPrescription = (tempTreatmentId: number, source: CancelTokenSource) => {
  return axios.delete(`${apiUri}/temp/${tempTreatmentId}`, {cancelToken: source.token})
      .then();
};

export const getTreatmentPrescriptionUrl = (treatmentDownloadKey: string): string => {
  return `${baseUrl}/537e28509a3748b891e1e7769b05bf2a/${treatmentDownloadKey}`
};

export const getTreatmentDownloadKey = (treatmentId: number, source: CancelTokenSource) => {
  return axios.get(`${baseUrl}/api/treatments/${treatmentId}/download-key`, {cancelToken: source.token})
      .then(response => response.data);
};
